import { ColumnDef } from '@/components/Table/types';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import { alignStyles } from './styles';

interface TableHeadCellProps<R> {
  cell: ColumnDef<R>;
  className?: string;
}

export const TableHeadCell = <R,>({
  cell,
  className,
}: TableHeadCellProps<R>): ReactElement => {
  return (
    <th scope="col" className={twMerge('p-2.5 text-xs font-bold', className)}>
      <div
        className={twMerge(
          'inline-flex w-full items-center',
          alignStyles[cell.alignment || 'center'],
        )}
      >
        {cell.render?.() ?? cell.name}
      </div>
    </th>
  );
};
